<template>
  <BModalFooter>
    <BLayout
      justify-center
      align-center
    >
      <BBtn
        class="mr-600"
        text
        :disabled="loading"
        @click="handleCancel"
      >
        {{ $t('general.cancel.text') }}
      </BBtn>
      <BBtn
        type="primary"
        :loading="loading"
        :disabled="disabled || loading"
        @click="handleSubmit"
      >
        {{ $t('general.update.text') }}
      </BBtn>
    </BLayout>
  </BModalFooter>
</template>

<script setup lang="ts">
type TProps = {
  loading: boolean;
  disabled: boolean;
};
type TEmit = {
  (event: 'cancel'): void;
  (event: 'submit'): void;
};

defineProps<TProps>();
const emit = defineEmits<TEmit>();

const handleCancel = () => {
  emit('cancel');
};

const handleSubmit = () => {
  emit('submit');
};
</script>
